import { useState } from "react";
import MobileSearchBox from "../../components/overlays/mobileSearchBox";
import { allLanguagesSearch, changeLanguage } from "../../lib/i18n";

const StartupLanguagePage = (props) => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    props?.defaultLanguage ? props?.defaultLanguage : "",
  );

  const handleButtonDisplay = () => {
    const button = document.getElementById("language-button");
    if (selectedLanguage.length > 0) {
      button.className = "startup-button-active";
    } else {
      button.className = "startup-button";
    }
  };
  return (
    <div
      style={{ background: "#fff", height: "max-content", padding: "10px" }}
      className="startup-language"
    >
      <MobileSearchBox
        pageName="ftu/language"
        searchContent={allLanguagesSearch}
        type="language"
        headerText="Please choose preferred language"
        handleButtonDisplay={handleButtonDisplay}
        setSelected={setSelectedLanguage}
        selected={selectedLanguage}
        isMobile={props.isMobile}
      />

      <button
        id="language-button"
        onClick={async (e) => {
          if (
            e.target.className.includes("startup-button") &&
            e.target.className !== "startup-button"
          ) {
            e.target.className = "startup-button-click";

            await changeLanguage(selectedLanguage);
            props.setPopupContent(null);
            props.setPopupContentPosition("center");
            props.setPageAction("");
            props.setShowPopup(false);
            if (props.setRefereshLanguage) {
              props.setRefereshLanguage(!props.refereshLanguage);
            }
          } else {
            const buttonElement = document.getElementsByClassName(
              "startup-button-active",
            );
            if (buttonElement.length > 0) {
              buttonElement[0].className = "startup-button-click";
              await changeLanguage(selectedLanguage);
              props.setPopupContent(null);
              props.setPopupContentPosition("center");
              props.setPageAction("");
              props.setShowPopup(false);
              if (props.setRefereshLanguage) {
                props.setRefereshLanguage(!props.refereshLanguage);
              }
            }
          }
        }}
        className="startup-button"
        style={{ marginBottom: "20px", marginTop: "10px" }}
      >
        <p className="st-button-text">Proceed</p>
      </button>
    </div>
  );
};

export default StartupLanguagePage;
